export enum ValidatorOptionRules {
  MINLENGTH = 'minlength',
  MAXLENGTH = 'maxlength',
}
